import { instance } from "./apiClient";

export const groupsApi = {
  setGroup: (group_id) =>
    instance.put("/groups/set", { group_id }).then((res) => res.data),

  getGroups: () => instance.get("/api/groups").then((res) => res.data),

  getOwnGroupsWithMembers: () =>
    instance.get("/api/groups/own_with_members").then((res) => res.data),

  createGroup: (payload) =>
    instance.post("/api/groups", payload).then((res) => res.data),

  updateGroup: (groupId, payload) =>
    instance.put(`/api/groups/${groupId}`, payload).then((res) => res.data),

  inviteUser: (payload) =>
    instance.post("/api/group_invitations", payload).then((res) => res.data),

  updateInvitation: (invitationId, payload) =>
    instance
      .put(`/api/group_invitations/${invitationId}`, payload)
      .then((res) => res.data),

  removeUserFromGroup: (groupId, userId) =>
    instance
      .put(`/api/groups/${groupId}/remove_user`, { user_id: userId })
      .then((res) => res.data),
};
